import { FAQS } from '../../config/site';
import { SectionHeader } from '../common';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

export default function FAQSection() {
  return (
    <section className="section">
      <div className="container-x" style={{ maxWidth: 860 }}>
        <div className="reveal"><SectionHeader center eyebrow="FAQ" title="Questions, answered." /></div>
        <Accordion type="single" collapsible className="reveal flex flex-col gap-3 mt-12">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="panel px-6" style={{ borderColor: 'var(--border)' }}>
              <AccordionTrigger className="text-left text-[16px] font-medium text-white hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[14.5px] text-[var(--muted)] leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
